const Dashboard = () => {
  return (
    <div>
      <h3>Dashboard</h3>
    </div>
  );
};

export default Dashboard;
